import request from '@/utils/request';

function createSummary(startDate, endDate) {
  return request({
    method: 'get',
    url: 'external-invoice/summary',
    params: {
      startDate: startDate,
      endDate: endDate
    },
    responseType: 'blob',
    timeout: 600000
  });
}

function createDetailed(month) {
  return request({
    method: 'get',
    url: 'external-invoice/details',
    params: {
      month: month
    },
    responseType: 'blob',
    timeout: 600000
  });
}

export const storeExtensions = {
  actions: {
    createSummary({ dispatch }, { startDate, endDate }) {
      return new Promise((resolve, reject) =>
        createSummary(startDate, endDate)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    createDetailed({ dispatch }, { month }) {
      return new Promise((resolve, reject) =>
        createDetailed(month)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
